export enum UserProfileStatusEnum {
  Loading = 'loading',
  Ready = 'ready',
  Stale = 'stale',
  Unavailable = 'unavailable',
}
